import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { DotsLoader } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import type { PendingFilterOptions } from "../../../models/PendingFilterModel";
import type { IFilterViewBaseModelProps } from "../../../types/filterInstance";

import { StyledPendingFilterBody, StyledPendingFilterDots } from "./styles";

/** The expanded body of a pending placeholder card: the definition's loading copy plus animated dots. */
export const PendingFilterView = ({ filter }: IFilterViewBaseModelProps<unknown, PendingFilterOptions>) => {
    const { translate } = useTranslate();

    const { bodyText } = filter.options;

    return (
        <StyledPendingFilterBody
            data-automation="filter-panel.pending-filter-body"
            alignItems="center"
            justifyContent="center"
            gap="8px"
        >
            <Text
                fontVariant="body2"
                color={colorsPalettes.carbon[300]}
            >
                {translate(bodyText.key, bodyText.replacements)}
            </Text>

            <StyledPendingFilterDots>
                <DotsLoader />
            </StyledPendingFilterDots>
        </StyledPendingFilterBody>
    );
};
